import { canChangeTicketStatus, canViewBusinessTravelTeamTab, canSubmitTicket } from 'Helpers/PermissionsHelper';

export const useTicketPermissions = (userRoles, ticketStatus) => {
  return {
    isChangeStatusDropDownHidden: !canChangeTicketStatus(userRoles, ticketStatus),
    isBussinesTravelTeamTabHidden: !canViewBusinessTravelTeamTab(userRoles, ticketStatus),
    isSubmitHidden: !canSubmitTicket(userRoles, ticketStatus),
  };
};
